import Vue from 'vue'
import Vuex from 'vuex'
import { omit } from 'lodash'

import configApp from './configApp'
import product from './product'
import plan from './plan'
import lead from './lead'
import steps from './steps'
import validatedSteps from './validatedSteps'
import personalData from './personalData'
import address from './address'
import promoCode from './promoCode'
import payment from './payment'
import sendQuotation from './sendQuotation'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    isLoading: false,
    urlParams: {}
  },
  modules: {
    configApp,
    product,
    plan,
    lead,
    validatedSteps,
    steps,
    personalData,
    address,
    promoCode,
    payment,
    sendQuotation
  }
})

store.subscribe((mutation, state) => {
  state = omit(state, [
    'payment.asyncPending',
    'payment.brand',
    'payment.numberCard',
    'payment.lastCardNumbers',
    'payment.nameCard',
    'payment.typePayment',
    'payment.validateCard',
    'payment.securityCode',
    'payment.cpfCard',
    'payment.campaign.promoCode',
    'payment.campaign.promoMessage',
    'payment.isActiveVoucher',
    'payment.paymentMethodData'
  ])

  sessionStorage.setItem('semprebem:checkout', JSON.stringify(state))
})

export default store
